import './store';
import Funds from './index';
import FundsRebateDetail from './rebateDetail/index';

export default [
  { path: '/home/funds', component: Funds },
  {
    path: '/home/funds/rebate-detail',
    alias: ['/home/funds/rebateDetail'],
    component: FundsRebateDetail,
  },
];
